import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { unwrapResult } from '@reduxjs/toolkit';

import { CustomAlert, CustomButton } from '../../../../../shared/uiComponents';
import { errorNormalizer } from '../../../../../shared/Helpers/functions';

import { DispatchProperties } from '../../../../../redux/store';
import { ArchiveClientBehaviorsProperties } from '../../../../../redux/API/ClientAPIHelpers/behaviorReductionProperties';
import { archiveBehavior, getBehaviors } from '../../../../../redux/State/clientSlice/behaviorReductionSlice';
import { Archive } from '../../../../../shared/Assets/svgIcons';
import { useScreenWidth } from '../../../../../shared/Helpers/hooks';

const ArchiveContent = ({ data, onClose }: { data: ArchiveClientBehaviorsProperties; onClose: () => void }) => {
	const dispatch = useDispatch<DispatchProperties>();
	const [params] = useSearchParams();

	const archiveHandler = () => {
		const includeArchived = params.get('includeArchivedBehavior') === 'true';
		const funderId = params.get('behaviorFunderId') || null;
		const clientId = data.clientId;
		dispatch(archiveBehavior(data))
			.then(unwrapResult)
			.then(() => {
				dispatch(getBehaviors({ clientId, includeArchived, funderId }));
			})
			.catch(errorNormalizer)
			.finally(() => onClose());
	};

	return (
		<>
			<CustomButton title="Yes" onClick={archiveHandler} className="marginBottom16" />
			<CustomButton title="Cancel" buttonType="secondaryGray" onClick={onClose} />
		</>
	);
};

const ArchiveComponent = ({ data, onlyIcon }: { data: ArchiveClientBehaviorsProperties; onlyIcon?: boolean }) => {
	const [open, setOpen] = useState<boolean>(false);
	const closeHandler = () => setOpen(false);

	const screenWidth = useScreenWidth();
	const isMobile = screenWidth <= 768;

	return (
		<>
			<CustomButton
				title={onlyIcon || isMobile ? '' : 'Archive'}
				buttonType="secondaryGray"
				onClick={() => setOpen(true)}
				startIcon={<Archive />}
			/>
			<CustomAlert
				title="Do you want to archive?"
				open={open}
				onClose={closeHandler}
				Content={() => <ArchiveContent data={data} onClose={closeHandler} />}
			/>
		</>
	);
};

export default ArchiveComponent;
